import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Tooltip from '@material-ui/core/Tooltip/index';

import ErrorIcon from '@material-ui/icons/Error';
import IconButton from '@material-ui/core/IconButton/index';
import Pageview from '@material-ui/icons/Pageview';

import {
  SoilDiagItem,
} from '../../../proptypes';

const MIN_WIDTH = 96;

export const Preview = (props) => {
  const {
    data,
    date,
    receiptId,
    receiptSubId,
    soilDiagItems,
    title,
  } = props;

  const [isOpened, setIsOpened] = useState(false);

  // HACK!
  // e.stopPropagation()でクリックした時に背面の行が選択されるのを抑制してる
  const onClickOuter = useCallback((e) => {
    e.stopPropagation();
  }, []);
  const onClickOpen = useCallback((e) => {
    e.stopPropagation();
    setIsOpened(true);
  }, []);
  const onClickClose = useCallback((e) => {
    e.stopPropagation();
    setIsOpened(false);
  }, []);

  const itemIds = Array.from(new Set(data ? data.map(d => d.item_id) : []));

  return (
    <div onClick={onClickOuter}>
      <IconButton onClick={onClickOpen}>
        <Pageview />
      </IconButton>
      <Dialog
        maxWidth="md"
        open={isOpened}
        onClose={onClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <div id="alert-dialog-description">
            {/* {body} */}
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH }}>受付番号</TableCell>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH }}>受付副番号</TableCell>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH }}>採土日</TableCell>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH + 16 }}>種類</TableCell>
                  <DataHeaderCells items={soilDiagItems} itemIds={itemIds} />
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key="row.v1">
                  <ValueCell value={receiptId} />
                  <ValueCell value={receiptSubId} />
                  <DateCell value={date} />
                  <TableCell>測定値</TableCell>
                  <DataBodyCells data={data} itemIds={itemIds} />
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClickClose} color="primary" autoFocus>
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const Data = PropTypes.shape({
  item_id: PropTypes.number.isRequired,
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  computed: PropTypes.number.isRequired,
});

Preview.propTypes = {
  data: PropTypes.arrayOf(Data).isRequired,
  date: PropTypes.string.isRequired,
  receiptId: PropTypes.number.isRequired,
  receiptSubId: PropTypes.number.isRequired,
  soilDiagItems: PropTypes.arrayOf(SoilDiagItem).isRequired,
  title: PropTypes.string.isRequired,
};


const DataHeaderCells = (props) => {
  const {
    items,
    itemIds,
  } = props;
  return (
    <>
      {
        itemIds.map((id) => {
          if (!items) {
            return <TableCell key={id} style={{ minWidth: MIN_WIDTH }} />;
          }
          const item = items.find(d => d.id === id);
          if (!item) {
            return <TableCell key={id} style={{ minWidth: MIN_WIDTH }} />;
          }
          return (
            <TableCell key={id} align="center" style={{ minWidth: MIN_WIDTH }}>
              {item.name}
            </TableCell>
          );
        })
      }
    </>
  );
};
DataHeaderCells.propTypes = {
  items: PropTypes.arrayOf(SoilDiagItem).isRequired,
  itemIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};


const DataBodyCells = (props) => {
  const {
    data,
    itemIds,
  } = props;
  return (
    <>
      {
        itemIds.map((id) => {
          if (!data) {
            return <TableCell key={id} style={{ minWidth: MIN_WIDTH }} />;
          }
          const item = data.find(d => d.item_id === id);
          if (!item) {
            return <TableCell key={id} style={{ minWidth: MIN_WIDTH }} />;
          }
          return (
            <TableCell key={id} align="center" style={{ minWidth: MIN_WIDTH }}>
              {item.computed}
            </TableCell>
          );
        })
      }
    </>
  );
};
DataBodyCells.propTypes = {
  data: PropTypes.arrayOf(Data).isRequired,
  itemIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};


const ValueCell = (props) => {
  const { value } = props;
  if (Number.isNaN(value)) {
    return (
      <TableCell align="center">
        <Tooltip title="値が正しくありません">
          <ErrorIcon color="error" />
        </Tooltip>
      </TableCell>
    );
  }
  return (
    <TableCell align="right">
      {value}
    </TableCell>
  );
};

ValueCell.propTypes = {
  value: PropTypes.number.isRequired,
};

const DateCell = (props) => {
  const { value } = props;
  if (!value || value === 'Invalid date') {
    return (
      <TableCell align="center">
        <Tooltip title="値が正しくありません">
          <ErrorIcon color="error" />
        </Tooltip>
      </TableCell>
    );
  }

  return (
    <TableCell align="right">
      {value}
    </TableCell>
  );
};

DateCell.propTypes = {
  value: PropTypes.string.isRequired,
};
